import { Component } from '@angular/core';
import { DeviceClient } from '../cms-bagha-api';

@Component({
    selector: 'app-notice-list',
    templateUrl: './notice-list.component.html',
  styleUrls: ['./notice-list.component.scss'],
  providers: [DeviceClient]
})
export class NoticeListComponent {
  noticeList: any;
  constructor(
    public dataService: DeviceClient  ) {

  }

  ngOnInit() {
    this.loadInitData();
    setTimeout(() => { window.location.reload() }, 50000);

  }
  loadInitData(): void {

    this.dataService.getNotices().subscribe(result => {
      this.noticeList = result.data;
      console.log('Mahtab', this.noticeList);
      });


     
  }
}
